import type { CancellationFeedback } from '../model/subscription.types';

export const SESSION_GENERATE_ACTION = 'session:generate' as const;

export const TRIAL_EARLY_ADOPTERS_PLAN_CODE = 'TRIAL_EARLY_ADOPTERS' as const;

export const OTHER_CANCELLATION_FEEDBACK = 'other' satisfies CancellationFeedback;

// Polling is the only thing that can reveal an activation whose push was lost, so it never stops
// outright — it just steps down once a settle has clearly overrun the webhook's normal latency.
export const CHECKOUT_SETTLE_POLL_INTERVAL_MS = 2_000;
export const CHECKOUT_SETTLE_POLL_BACKOFF_AFTER_MS = 30_000;
export const CHECKOUT_SETTLE_SLOW_POLL_INTERVAL_MS = 10_000;

// Reason options for the cancel-plan flow. Values are Stripe's
// `cancellation_details[feedback]` enum; order and copy follow the Stripe config.
export const CANCELLATION_REASONS: ReadonlyArray<{
    value: CancellationFeedback;
    label: string;
}> = [
    { value: 'too_expensive', label: "It's too expensive" },
    { value: 'switched_service', label: 'I found an alternative' },
    { value: 'unused', label: 'I no longer need it' },
    { value: 'missing_features', label: 'I need more features' },
    { value: 'customer_service', label: 'Customer service was lacking' },
    { value: 'low_quality', label: 'Quality was lacking' },
    { value: 'too_complex', label: 'It was too complex to use' },
    { value: OTHER_CANCELLATION_FEEDBACK, label: 'Other reason' },
];
